import { type AvailableAccessKeyInstance } from '@/types/trpc/accessKeys';
import { type CellProps } from '@/shared/hooks/table/types';
import TruncatedCell from '@/shared/components/2.0/customTableCells/TruncatedCell';

const AccessKeyAvailableBuildingUnitsTableCell: React.FC<
  CellProps<AvailableAccessKeyInstance>
> = ({ rowData }) => {
  const text =
    rowData.buildingUnits?.map((u) => u.registrationNumber).join(', ') || '-';

  return <TruncatedCell value={text} />;
};

export default AccessKeyAvailableBuildingUnitsTableCell;
